export default __webpack_public_path__ + "static/kitchen_cover-58ca824cc36e95d2dea1c964a643b9d9.png";